export enum CompetitorTypes {
  Entity = "ENTITY",
  Person = "PERSON",
}
